import SvgCameraNavIconSecondary from './svgs/CameraNavIconSecondary.js';
import SvgCameraNavIcon from './svgs/CameraNavIcon.js';
import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import { useIcon } from '../../shared-components/icon/index.js';

var cameraNavIcon = (props => useIcon(SvgCameraNavIcon, SvgCameraNavIconSecondary, props));

export { cameraNavIcon as default };
